import { Button } from "antd"

import { AttendanceStatus } from "#customTypes/types"

import AttendanceIcon from "./AttendanceIcon"

const BUTTON_SIZE = {
  small: 20,
  medium: 26,
  large: 32,
}

// The buttons seem to sit high, so move them down
const MARGIN_TOP = 3

const AttendanceButton = ({
  status,
  onClick,
  disabled,
  size = "medium",
}: {
  status: AttendanceStatus
  onClick: () => void
  disabled?: boolean
  size?: "small" | "medium" | "large"
}) => {
  return (
    <Button
      data-testid={`attendance-button-${status}`}
      onClick={onClick}
      style={{
        cursor: disabled ? "default" : "pointer",
        opacity: status === status ? 1 : 0.7,
        width: BUTTON_SIZE[size],
        height: BUTTON_SIZE[size],
        minWidth: BUTTON_SIZE[size],
        minHeight: BUTTON_SIZE[size],
        marginTop: MARGIN_TOP,
      }}
      shape="circle"
      disabled={disabled}
    >
      <AttendanceIcon status={status} size={size} />
    </Button>
  )
}

export default AttendanceButton
